import React, { useContext, useEffect, useState } from "react";
import _ from "lodash";
import "./ProductChoices.less";
import Pricing from "../home/Pricing";


export const ProductChoices: React.FC<any> = () => {
    return (
        <Pricing></Pricing>
    );
};
